import React from 'react';

export const ReadIcon = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.06787 8.97998C1.06787 8.97998 5.06787 0.97998 12.0679 0.97998C19.0679 0.97998 23.0679 8.97998 23.0679 8.97998C23.0679 8.97998 19.0679 16.98 12.0679 16.98C5.06787 16.98 1.06787 8.97998 1.06787 8.97998Z"
      strokeWidth="1.25"
    />
    <path
      d="M12.0679 11.98C13.7247 11.98 15.0679 10.6368 15.0679 8.97998C15.0679 7.32313 13.7247 5.97998 12.0679 5.97998C10.411 5.97998 9.06787 7.32313 9.06787 8.97998C9.06787 10.6368 10.411 11.98 12.0679 11.98Z"
      strokeWidth="1.25"
    />
  </svg>
);
